import React, { Component } from 'react';
import { connect } from 'react-redux';
import { constants } from '../login/store';
import { Toast } from 'antd-mobile';
import Api from '../../utils/Api';
import { ParseParams } from '../../utils/params';
const getApi = Api.getInstance;

class Start extends Component {

  constructor(props) {
    super(props);
    this.state = {
    }
  }
  render() {
    return (
      <div></div>
    )
  }
  async componentDidMount() {
    let params = ParseParams(window.location.search);
    let {state} = params;
    /** state格式(服务器生成链接) clientType+page page如果以close_开头，需要关闭页面 */
    if(state && state.indexOf('+')!=-1){
      let array= state.split("+");
      params.clientType=array[0];
      params.state = array[1];
      if (params.state.startsWith("close_")) {
        params.close = 1;
        params.state = params.state.replace("close_", "");
      }
      else {
        params.close = 0;
      }
    }
    console.log("startParams:" + JSON.stringify(params));

    if (params.clientType) {
      this.props.setClientType({ clientType: params.clientType });
    }
    try {
      this.getSetting(params);
      await this.login(params);
    }
    finally {
      let { state = '', id = 0, recommend, topicId,image } = params;
      /** state格式 page_id_recommend */
      let array = state.split("_");
      if (array.length > 1) {
        state = array[0];
        id = array[1];
        console.log("state1===="+state+"===id==="+id)
      }
      if (array.length > 2) {
        recommend = array[2];
      }
      console.log("recommend===="+recommend)

      if (state === 'goodsShared') {
        this.props.history.push('/' + state + '?id=' + id + '&recommend=' + recommend)
      }
      else if (state === 'topicList') {
        this.props.history.push('/topicList?topicId=' + topicId);
      }
      else if(state === 'login'){
        this.props.history.replace("/register?recommend=" + recommend)
      }
      else if(state === 'bindMobile' || state === 'waimai' || state === 'meituan' || state === 'elm' || state === 'freeOrderList' || state === 'fanliCourse'){
        this.props.history.replace("/login?recommend=" + recommend+"&closeFlag="+params.close+"&state="+state);
      }
      else if(state === 'siteDetailList'){
        this.props.history.replace("/shareSiteDetailList?siteDetailId=" + id+"&recommend="+recommend)
      }
      else if(state === 'productInfo'){
        this.props.history.replace("/shareProductInfo?itemId=" + id+"&recommend="+recommend+'&tlj='+0)
      }
      else if (state === 'wechatQr') {
        this.props.history.replace("/wechatQr?id=" + id)
      }
      // 公众号按钮-每日签到
      else if (state === 'qiandao') {
        this.props.history.replace("/signIn")
      }
      // 公众号按钮-推荐有奖
      else if (state === 'invite') {
        this.props.history.replace("/invite")
      }
      // 公众号按钮-返利帮助
      /* else if (state === 'tbHelp') {
        this.props.history.replace("/fanliCourse")
      } */
      // 公众号按钮-投诉建议
      else if (state === 'advice') {
        this.props.history.replace("/feedback")
      }
      // 提现
      else if (state === 'customerList' || state === 'takeCash') {
        this.props.history.replace("/wallet")
      }
      // 返利帮助
      else if (state === 'tbHelp') {
        this.props.history.replace("/rebate")
      }
      // 小惠云超拉新页面
      else if (state === 'yunChaoCash') {
        this.props.history.replace("/inviteYunChao?recommend=" + recommend+"&closeFlag="+params.close+"&state="+state);
      }
      else {
        // this.props.history.replace("/wallet")
        this.props.history.replace("/index");
        // this.props.history.replace("/indexTest");
      }
    }
  }
  async login(params) {
    let {userInfo} = this.props;
    console.log("code1======"+params.code)
    if (params.code) {
      let recommend = null;
      if (params.state) {
        let array = params.state.split("_");
        if (array.length > 2) {
          recommend = array[2];
        }
      }
      let res = await getApi().codeLogin({
        code: params.code,
        clientType: params.clientType,
        recommend: recommend,
        uuid: "mall",
      });
      if (res.module) {
        console.log("login params:" + JSON.stringify(params));
        console.log("code2======"+params.code)
        this.props.setUserInfo(res.module);
      }
      else {
        Toast.info(res.error, 1)
      }
    }
    else if (userInfo && userInfo.token && userInfo.customerId) {
        let res = await getApi().tokenLogin({
          token: userInfo.token,
          customerId: userInfo.customerId,
          // token:"6c20660f75af4e2ea37a5d088a10e60f",
          // customerId:"e4819d9a156348dd978a"
        });
        if (res.module) {
          this.props.setUserInfo(res.module);
        }
        else {
          Toast.info(res.error, 1)
        }
    }
  }
  
  getSetting(params) {
    getApi().doSettingInfo({
      clientType: params.clientType,
    }).then(res => {
      if (res.module) {
        this.props.setSetting(res.module);
      }
      else {
        Toast.info(res.error, 1)
      }
    })
  }
}

const mapState = (state) => ({
  userInfo: state.login.userInfo,
  clientType: state.login.clientType
})

const mapDispatch = (dispatch) => ({
  setUserInfo(item) {
    dispatch({
      type: constants.USERINFO,
      payload: item
    })
  },
  setClientType(value) {
    dispatch({
      type: constants.CLIENT_TYPE,
      payload: value,
    })
  },
  setSetting(value) {
    dispatch({
      type: constants.SETTING,
      payload: value,
    })
  },
})

export default connect(mapState, mapDispatch)(Start);